import { featureThumbnailUrl } from "../../misc/helpers";
import { convertImgToBase64URL, THUMBNAIL_SIZES } from "../../misc/utils";

export const loadImageFromDataUrl = (dataUrl: string): Promise<HTMLImageElement | null> =>
  new Promise((resolve) => {
    if (!dataUrl) { resolve(null); return; }
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => resolve(null);
    img.src = dataUrl;
  });

export const fetchWithProxies = async (url: string): Promise<string | null> => {
  if (!url) return null;
  const proxiedUrls = [
    `https://corsproxy.io/?url=${encodeURIComponent(url)}`,
    `https://proxy.corsfix.com/?${url}`,
    url,
  ];
  for (const proxiedUrl of proxiedUrls) {
    try {
      const dataUrl = await convertImgToBase64URL(proxiedUrl);
      if (dataUrl) return dataUrl;
    } catch (e) {
      console.warn(`[aiThumbnailsLoad] proxy failed for ${proxiedUrl}:`, e);
    }
  }
  return null;
};

export const loadThumbnail = async (feature: object): Promise<HTMLImageElement | null> => {
  const sizes = [THUMBNAIL_SIZES.large, THUMBNAIL_SIZES.medium, THUMBNAIL_SIZES.small];
  for (const size of sizes) {
    try {
      const url = featureThumbnailUrl(feature, size);
      const dataUrl = await fetchWithProxies(url);
      if (dataUrl) return loadImageFromDataUrl(dataUrl);
    } catch (e) {
      console.warn(`[aiThumbnailsLoad] failed to load thumbnail at size ${size}:`, e);
    }
  }
  return null;
};
